<template>
    <div class="border mt-3 p-3" v-if="isInitial && isLogin" data-cy="container_user_info">
        <div class="text-lg font-bold" data-cy="text_user_info_title">Profile</div>
        <!-- <div v-if="profile != null"> -->
            <div data-cy="text_user_info_display_name">{{profile.displayName}}</div>
            <div data-cy="text_user_info_email">{{profile.email}}</div>
            <div data-cy="text_user_info_contact_number">{{FilterPhoneFormat(profile.contactNumber)}}</div>
            <div data-cy="text_user_info_birthdate">Brithdate: {{FilterDateFormat(profile.birthDate)}}</div>
            <div data-cy="text_user_info_join_date">Join Date: {{FilterDateFormat(profile.joinDate)}} {{FilterTimeFormat(profile.joinDate)}}</div>
            <div data-cy="text_user_info_point">Point {{FilterNumberFormat(profile.updated_points.points)}}</div>
        <!-- </div> -->
        <div>
            <router-link to="/profile" class="bg-green-400 py-1 px-2 text-white rounded-md" data-cy="btn_user_info_edit_profile">Edit profile</router-link>
            <button class="bg-red-400 py-1 px-2 text-white rounded-md ml-2" @click="clickLogout()" data-cy="btn_user_info_logout">Logout</button>
        </div>

        <div data-cy="container_user_info_test_zone">
            <div>test zone</div>
            <div data-cy="text_user_info_date_valid">date valid: {{isDateValid}}</div>
        </div>
    </div>
</template>
<script>
// import { mapState } from 'vuex';
import Account from '@/helper/AccountHelper.js';
// import Util from "@/helper/Utility.js";
import DatetimeHelper from '@/helper/DatetimeHelper.js';
//mixin
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';

export default {
    name: "UserInfo",
    inject: ["AccountStore"],
    mixins: [AuthStatusMixin],
    props: {
        modalController: Object,
    },
    data: function() {
        return {
            isDateValid: false,
        };
    },
    computed: {
        profile: function() {
            return this.AccountStore.state.profile;
        },
    },
    created: function() {
        this.AccountStore.methods.loginStatus().subscribe((status) => {
            console.log("login status: " + status);
            if (status) {
                this.testRun();
            }
        });
    },
    methods: {
        clickLogout: function() {
            this.modalController.confirmModal
                    .clearModal()
                    .setMsg("Logout?")
                    .show();
            this.modalController.confirmModal.onClickOk(() => {
                this.modalController.loadingModal.show();
                Account.setLogout().then(() => {
                    window.location.reload();
                }).catch(() => {
                    window.location.reload();
                });
            });
        },

        testRun: function() {
            let timestamp = this.profile.joinDate;
            let date = DatetimeHelper.timeFormat(timestamp);
            console.log('print', date);
        }
    },
}
</script>
<style lang="scss" scoped>

</style>
